import { Controller } from '@hotwired/stimulus';

const SELECTED_CLASS = 'ui-tab-selector__tab--selected';

export default class extends Controller {
  static targets = ['tab', 'input'];

  select(event) {
    this.activate(event.currentTarget);
  }

  // Moving focus also picks, the pattern for tabs that swap a panel.
  navigate(event) {
    const step = { ArrowRight: 1, ArrowLeft: -1 }[event.key];
    const jump = { Home: 0, End: this.tabTargets.length - 1 }[event.key];
    if (step === undefined && jump === undefined) return;

    event.preventDefault();
    const from = this.tabTargets.indexOf(event.currentTarget);
    const to = step === undefined
      ? jump
      : (from + step + this.tabTargets.length) % this.tabTargets.length;

    this.activate(this.tabTargets[to]);
    this.tabTargets[to].focus();
  }

  activate(tab) {
    if (tab.classList.contains(SELECTED_CLASS)) return;

    this.tabTargets.forEach((candidate) => {
      const chosen = candidate === tab;

      candidate.classList.toggle(SELECTED_CLASS, chosen);
      candidate.setAttribute('aria-selected', String(chosen));
      candidate.tabIndex = chosen ? 0 : -1;
      this.togglePanel(candidate, chosen);
    });

    const value = tab.dataset.tabSelectorComponentValueParam;

    if (this.hasInputTarget && value !== undefined) {
      this.inputTarget.value = value;
      this.inputTarget.dispatchEvent(new Event('change', { bubbles: true }));
    }

    this.dispatch('change', { detail: { value } });
  }

  togglePanel(tab, visible) {
    const id = tab.dataset.tabSelectorComponentPanelParam;
    if (!id) return;

    const panel = document.getElementById(id);
    if (panel) panel.hidden = !visible;
  }
}
